import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    constructor() {
    }

    compare(v1: number, v2: number, tolerance: number): number {
        if (v1 <= v2 * (1 + tolerance / 100) && v1 >= v2 * (1 - tolerance / 100)) {
            return 0;
        } else if (v1 > v2) {
            return 1;
        } else if (v1 < v2) {
            return -1;
        }
        return 0;
    }


    percentLabel(value: number) {
        return value + '%';
    }

    euroLabel(value: number) {
        return value + '€';
    }

    zipcodeLabel(value) {
        if (value === null) {
            return '';
        }
        if (typeof value === 'string') {
            return value;
        }
        return value.zip_code;
    }

    cityLabel(value) {
        if (value === null) {
            return '';
        }
        if (typeof value === 'string') {
            return value;
        }
        return value.name;
    }

    round(n) {
        if (isNaN(n)) {
            return 0;
        }
        if (n === Math.round(n)) {
            return Math.round(n);
        }
        return n.toFixed(1);
    }

    formatDate(date: Date) {
        return (date.getDate() <= 9 ? '0' : '') + date.getDate() + '/' + (date.getMonth() + 1 <= 9 ? '0' : '') + (date.getMonth() + 1) + '/' + date.getFullYear();
    }

    getStatusLib(key) {
        switch (key) {
            case 'analyse' :
                return 'Analyse en cours';
                break;
            case  'contact':
                return 'A contacter';
                break;
            case 'visite':
                return ' A visiter';
                break;
            case 'offre':
                return 'Offre à faire';
                break;
            case 'offre_ok':
                return 'Offre acceptée';
                break;
            case 'offre_ko':
                return 'Offre refusée';
                break;
            case 'sell' :
                return 'Déjà vendu';
                break;
            case 'abandon':
                return 'Pas intéressant';
                break;
            case 'offre_reponse':
                return 'En attente retour';
                break;
            case 'buy':
                return 'Propriétaire';
                break;
        }
    }
}
